const archive_kop = () => import(/* webpackPrefetch: true */ '@/views/private/archive/kop/index.vue')

const archive_template = () => import(/* webpackPrefetch: true */ '@/views/private/archive/template/index.vue')

const archive_folder = () => import(/* webpackPrefetch: true */ '@/views/private/archive/folder/index.vue')


const routes = [
  {
    path: "/archive/kop",
    name: "Kop Surat",
    component: archive_kop,
    meta: {
      title: "Kop Surat"
    }
  },


  {
    path: "/archive/template",
    name: "Template",
    component: archive_template,
    meta: {
      title: "Template"
    }
  },


  {
    path: "/archive/folder",
    name: "Folder",
    component: archive_folder,
    meta: {
      title: "Folder"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})